import { ActivityType, PermissionGroupId } from "../DTOs";
import { DateBuilder } from "../util";
import { Activity, MeetingInvitationSnapshot } from '../DTOs/Activity';

export const activityHelper =
{
    allowParticipants:(activityType:ActivityType) =>
    {
        return [
            'AnnualWorkgroupStatus', 
            'WorkgroupMeeting',
            'SafetyInspection'
        ].find(t => t === activityType) !== undefined;
    },

    allowTargetUserAsParticipant: (pgId:PermissionGroupId) =>
    {
        const allowedTargetPermissionGroups:PermissionGroupId[] = [
            'superadmin', 
            'siteadmin',
            'member'
        ];
        return allowedTargetPermissionGroups.find(pg => pg === pgId) !== undefined;
    },

    getMeetingInvitationSnapshot:(activity:Activity):MeetingInvitationSnapshot => 
    {
        const allowedTypes:ActivityType[] = ['AnnualWorkgroupStatus', 'WorkgroupMeeting', 'SafetyInspection'];
        if(!allowedTypes.some(t => t === activity.activityType))
            throw new Error(`invalid activity type: ${activity.activityType}`);

        const state:MeetingInvitationSnapshot = {
            activityId: activity.id,
            title: activity.title,
            description: activity.description,
            start: new DateBuilder(activity.start).zeroSeconds().date,
            end: new DateBuilder(activity.end).zeroSeconds().date,
            location: activity.location,
            agendaItems: activity.agendaItems.map(ai => ai.title),
            participants: activity.participants
                .map(p => ({ id:p.id, email:p.email, name:p.name }))
                .sort((a,b) => a.id.localeCompare(b.id))
        };

        return state;
    }
}